import api from "../../../services/axiosConfig";

export const fetchDatasources = async () => {
  try {
    const response = await api.get(
      "/instances/governeye/jeyeda/list-datasources",
      {
        data: {},
      },
    );

    return response.data?.data?.datasources || [];
  } catch (error) {
    console.error("Error fetching datasources:", error);
    throw error;
  }
};
